import dayjs from 'dayjs';
import { BarItem, TimeActive } from '.';
import { keepTwoNull } from '@/utils/utils';

export const getChartOption = (data: BarItem[], timeType: TimeActive) => {
  const formatStr = timeType === TimeActive.THIS_MONTH ? 'MM-DD' : 'YYYY-MM';
  return {
    backgroundColor: 'transparent',
    color: ['#2D8DFF', '#16DD8E'],
    grid: {
      left: 10,
      right: 30,
      bottom: 16,
      containLabel: true,
    },
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format(formatStr);
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          const value = keepTwoNull(data[1]);
          otherStr += `<div style="margin-top:8px;width:200px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${value}kWh</div></div></div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    legend: [
      {
        right: 0,
        itemHeight: 16,
        itemWidth: 16,
        itemGap: 24,
        data: [
          {
            name: '市电',
            icon: 'rect',
          },
        ],
      },
      {
        right: 80,
        itemHeight: 16,
        itemWidth: 16,
        itemGap: 24,
        data: [
          {
            name: '光伏发电',
            icon: 'rect',
          },
        ],
      },
    ],
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e).format(formatStr);
          },
          hideOverlap: true,
        },
        boundaryGap: true,
      },
    ],
    yAxis: [
      {
        name: 'kWh',
        nameTextStyle: {
          color: 'rgba(255,255,255,0.85)',
          fontSize: 14,
        },
        type: 'value',
        splitLine: {
          lineStyle: { color: 'rgba(255,255,255,0.30)' },
        },
        axisLabel: {
          color: 'rgba(255,255,255,0.85)',
          fontSize: 14,
        },
      },
    ],
    series: [
      {
        name: '市电',
        stack: 'total',
        type: 'bar',
        barWidth: 8,
        data: data.map((a, index) => {
          return [a.ts, a.electricity];
        }),
      },
      {
        name: '光伏发电',
        stack: 'total',
        type: 'bar',
        barWidth: 8,
        data: data.map((a, index) => {
          return [a.ts, a.pvPower];
        }),
      },
    ],
  };
};
